import { GenericService } from 'services/genericService';
import { Observable } from 'rxjs';
import { SearchResults } from 'utils/api/models/search/searchResults';
import { searchNumbersAndUsersRestPost } from 'utils/api/queries/omantelApi';

export class SearchService extends GenericService {
	public static searchNumbersAndUsersRestPost(searchText: string): Observable<SearchResults> {
		return searchNumbersAndUsersRestPost(searchText).call();
	}
}
